// src/App.tsx

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';

// Компоненты
import Layout from './components/common/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';
import RoleRoute from './components/common/RoleRoute';
import NotFound from './components/common/NotFound';
import Dashboard from './components/dashboard/Dashboard';
import Calendar from './components/calendar/Calendar';
import Students from './components/students/Students';
import Groups from './components/groups/Groups';
import About from './components/about/About';
import Profile from './components/profile/Profile';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ChangePassword from './components/auth/ChangePassword';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
                <Routes>
                    {/* Публичные */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />

                    {/* Требует авторизации, но БЕЗ Layout */}
                    <Route
                        path="/change-password"
                        element={
                            <ProtectedRoute>
                                <ChangePassword />
                            </ProtectedRoute>
                        }
                    />

                    {/* Защищённые внутри Layout */}
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Navigate to="/dashboard" replace />} />

                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="calendar" element={<Calendar />} />
                        <Route path="profile" element={<Profile />} />

                        <Route
                            path="students"
                            element={
                                <RoleRoute allowedRoles={['ROLE_TEACHER', 'ROLE_ADMIN']}>
                                    <Students />
                                </RoleRoute>
                            }
                        />
                        <Route
                            path="groups"
                            element={
                                <RoleRoute allowedRoles={['ROLE_TEACHER', 'ROLE_ADMIN']}>
                                    <Groups />
                                </RoleRoute>
                            }
                        />
                        <Route path="about" element={<About />} />

                        <Route path="404" element={<NotFound />} />
                        <Route path="*" element={<Navigate to="/404" replace />} />
                    </Route>
                    <Route path="/invite/:token" element={<Register />} />
                    <Route path="/register" element={<Register />} />  {/* для случая без токена */}

                </Routes>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;